import script from "./ProspeccaoMatricChart.vue?vue&type=script&setup=true&lang=js"
export * from "./ProspeccaoMatricChart.vue?vue&type=script&setup=true&lang=js"

import "./ProspeccaoMatricChart.vue?vue&type=style&index=0&id=66fcd668&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66fcd668"]])

export default __exports__